import React, { useState, useEffect } from 'react'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import { EMPTY_OBJECT } from './AddTaskList'

function CreateCube(props) {
    const [isLoadingRequest, setIsLoadingRequest] = useState(false)
    const [databaseId, setDatabaseId] = useState(-1)
    const [dataSourceSystemName, setDataSourceSystemName] = useState('')
    const [databaseName, setDatabaseName] = useState('')
    const [sqLDbList, setSqLDbList] = useState([])
    const [dataSources, setDataSources] = useState([])
    const [ssasServers, setSsasServers] = useState([])
    const [selectedSsasServer, setSelectedSsasServer] = useState(-1)
    const [dataSourceName, setDataSourceName] = useState('')
    const [createDataSourceName, setCreateDataSourceName] = useState('')

    // trigger on component mount
    useEffect(() => {
        if (sqLDbList.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 0)
            setSqLDbList(dBList)
        }

        if (ssasServers.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 1)
            setSsasServers(dBList)
        }

        if (props.taskData.originDatabaseId && props.taskData.originDatabaseId > -1) {
            setSelectedSsasServer(props.taskData.originDatabaseId)
        } else {
            setSelectedSsasServer(-1)
        }

        if (props.taskData.dataSourceName) {
            setDataSourceName(props.taskData.dataSourceName)
        } else {
            setDataSourceName('')
        }
    }, [])

    useEffect(() => {
        if (props.taskData.databaseId !== -1) {
            if (props.taskData.databaseId !== databaseId) {
                setDatabaseId(props.taskData.databaseId)
                setIsLoadingRequest(true)
                
                let getDataSources = props.getDataSources(props.taskData.databaseId)
                getDataSources.then((resp) => { 
                    if (resp.status !== 200) {
                        throw new Error(resp)
                    } else {
                        return resp.json()
                    }
                }).then((json) => {
                    setDataSources(json)
                    setIsLoadingRequest(false)
                    setDataSourceSystemName(props.taskData.dataSourceSystemName)
                    if (systemNameNotInDictionary(props.taskData.dataSourceSystemName, json)) {
                        let altName = getAlternativeSystemNameFromDataSourceName(props.taskData.originDatabaseDataSourceSystemName, json)
                        setDataSourceSystemName(altName)
                    }
                }).catch((ex) => {
                    console.error(ex)
                    setDataSources([])
                    setIsLoadingRequest(false)
                })

                setDatabaseName(props.taskData.databaseName)
            }
        } else {
            setDatabaseId(-1)
            setDataSourceSystemName('')
            setIsLoadingRequest(false)
            setDataSources([])
            setDatabaseName('')
        }

        if (props.taskData.originDatabaseId && props.taskData.originDatabaseId > -1) {
            setSelectedSsasServer(props.taskData.originDatabaseId)
        } else {
            setSelectedSsasServer(-1)
        }

        if (props.taskData.dataSourceName) {
            setDataSourceName(props.taskData.dataSourceName)
        } else {
            setDataSourceName('')
        }
    }, [
        props.taskData.databaseId,
        props.taskData.dataSourceSystemName,
        props.taskData.databaseName,
        props.taskData.originDatabaseId,
        props.taskData.dataSourceName
    ])

    function handleDatabase(event) {
        event.preventDefault()
        setDatabaseId(event.target.value)
        setDataSourceSystemName('')
        setIsLoadingRequest(true)
        setDataSources([])
        setDatabaseName('')

        let getDataSources = props.getDataSources(event.target.value)
        getDataSources.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            let dbName = ''
            sqLDbList.forEach(db => {
                if (db.id === event.target.value) {
                    setDatabaseName(db.dBname)
                    dbName = db.dBname
                }
            })
            setDataSources(json)
            setIsLoadingRequest(false)
            fireOnSaveEvent(event.target.value, dbName, "", selectedSsasServer, dataSourceName. createDataSourceName)
        }).catch((ex) => {
            console.error(ex)
            setDataSources([])
            setIsLoadingRequest(false)
        })
    }

    function handleDataSourceChange(event) {
        event.preventDefault()
        setDataSourceSystemName(event.target.value)

        dataSources.forEach((ds) => {
            if (ds.key === event.target.value) {
                setCreateDataSourceName(ds.value)
                fireOnSaveEvent(databaseId, databaseName, event.target.value, selectedSsasServer, dataSourceName, ds.value)
            }
        })
    }

    function handleSsasServer(event) {
        event.preventDefault()
        setSelectedSsasServer(event.target.value)
        fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, event.target.value, dataSourceName, createDataSourceName)
    }

    /**
     * If component has a prop for the [onSave] event, the purpose of this is to fire that event with the latest information
     * @param {int} dbId - Selected database ID
     * @param {string} dbName - Selected name of the database
     * @param {string} dsSystemName - Data source system name from the selected database
     * @param {int} ssasServerId - SSAS Server From Database
     * @param {string} cubeName - Cube Name
     * @param {string} originDataSourceName - Name of the original data source that we created the cube from
     */
    function fireOnSaveEvent(dbId, dbName, dsSystemName, ssasServerId, cubeName, originDataSourceName) {
        if (props.onSave) {
            let copied = JSON.parse(JSON.stringify(EMPTY_OBJECT))
            copied["databaseId"] = dbId
            copied["databaseName"] = dbName
            copied["dataSourceSystemName"] = dsSystemName
            copied["dataSourceName"] = cubeName
            copied["originDatabaseId"] = ssasServerId
            copied["originDatabaseDataSourceSystemName"] = originDataSourceName
            props.onSave(copied)
        }
    }

    function systemNameNotInDictionary(systemName, dictionary) {
        for (let x = 0; x < dictionary.length; x++) {
            let current = dictionary[x]
            if (current["key"] === systemName) {
                return false
            }
        }
        return true
    }

    function getAlternativeSystemNameFromDataSourceName(dsName, dictionary) {
        for (let x = 0; x < dictionary.length; x++) {
            let current = dictionary[x]
            if (current["value"] === dsName) {
                return current["key"]
            }
        }
        return ''
    }

    // This is the render logic, no need to declare another method is a functional component
    return (
        <Paper elevation={3} className="dbFunctionsPaper">
            <h3>Create Cube</h3>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-databse-label">Select Database</InputLabel>
                <Select
                    labelId="select-databse-label"
                    id="select-databse"
                    label="Select Database"
                    onChange={handleDatabase}
                    defaultValue={sqLDbList.length > 0 ? sqLDbList[0].id : -1}
                    value={databaseId}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={-1}>Select Database</MenuItem>
                        { sqLDbList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-data-source-label">Select Data Source</InputLabel>
                <Select
                    labelId="select-data-source-label"
                    id="select-data-source"
                    label="Select Data Source"
                    onChange={handleDataSourceChange}
                    value={dataSourceSystemName}
                    defaultValue={''}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={''}>Select Data Source</MenuItem>
                        { dataSources.map((x) => x && <MenuItem key={x.key} value={x.key}>{x.value}</MenuItem>) }
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <InputLabel id="select-ssas-database-server-label">SSAS Database Server</InputLabel>
                <Select
                    labelId="select-ssas-database-server-label"
                    id="select-ssas-database-server"
                    label="SSAS Database Server"
                    onChange={handleSsasServer}
                    defaultValue={ssasServers.length > 0 ? ssasServers[0].id : -1}
                    value={selectedSsasServer}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={-1}>Select SSAS Database Server</MenuItem>
                        { ssasServers.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <TextField
                    fullWidth
                    label="Cube Name"
                    variant="outlined"
                    value={dataSourceName}
                    disabled={false}
                    onChange={(e) => {
                        e.preventDefault()
                        setDataSourceName(e.target.value)
                        fireOnSaveEvent(databaseId, databaseName, dataSourceSystemName, selectedSsasServer, e.target.value, createDataSourceName)
                    }} />
            </FormControl>
        </Paper>
    )
}

export default CreateCube